// Auto-generated skeleton for Message

import { Building } from "./Building";
import { Unit } from "./Unit";
import { User } from "./User";

export const Message: Api.Message = {
  id: 0,
  documents: [],
  building_id: 0,
  building: Building,
  unit_id: 0,
  unit: Unit,
  receiver_user_id: 0,
  receiver_user: User,
  sender_user_id: 0,
  sender_user: User,
  send_copy: false,
  done: false,
  resubmission_hp_id: 0,
  message: '',
  synced_at: null,
  created: null,
  updated: null,
};

